<div class="container-fluid mt-3 ">
    <div class="row rounded-1 background-light mb-3 py-3">
        <div class="col">
            @for (app of AppareilList; track app; let i = $index) {
            <div class="row rounded-1 align-items-center m-3 py-3 background">

                
                <div class="col-4 text-end fw-bold">Type</div>
                <div class="col-8"> {{getAppareilType(app)}}</div>
                <div class="col-4 text-end fw-bold">Marque</div>
                <div class="col-8"> {{getBrandLabel(app)}}</div>
                <div class="col-4 text-end fw-bold">Modèle</div>
                <div class="col-8 ">{{getModelLabel(app)}}</div>

                <div class="col-12 text-end">
                    <button appPreventDoubleClick class="" color="primary" mat-icon-button (throttledClick)="openAppareil(app)">
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                    </button>
                    <!-- <button appPreventDoubleClick class="" color="warn" mat-icon-button (throttledClick)="deleteAppareil(app)">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button> -->
                </div>
            </div>
            }
            <div class="row align-items-center m-1">
                <button appPreventDoubleClick class="col" color="primary" mat-raised-button (throttledClick)="openAppareil()">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
                </button>
            </div>
        </div>
    </div>
</div>